export const iconFontAwesomeHumanitarianXmarksLines = (
	<i className="fa-solid fa-xmarks-lines"></i>
);
